import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import request from '../utils/request';

function MatchSuccess() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const wechatText = useMemo(() => data?.wechat || '', [data]);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const res = await request({ url: `/api/match/${id}/contact`, method: 'GET' });
        setData(res.data);
      } catch (err) {
        setError(err.response?.data?.error || '获取失败');
      } finally {
        setLoading(false);
      }
    };
    fetchContact();
  }, [id]);

  const copyWechat = async () => {
    if (!wechatText) return;
    try {
      await navigator.clipboard.writeText(wechatText);
      alert('✅ 已复制微信号');
    } catch (e) {
      // 兼容部分微信 WebView 不支持 clipboard API
      const input = document.createElement('input');
      input.value = wechatText;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert('✅ 已复制微信号');
    }
  };

  return (
    <div className="container">
      <div style={{ padding: '20px 0' }}>
        <button
          className="btn btn-secondary"
          onClick={() => navigate('/discover')}
          style={{ marginBottom: 16 }}
        >
          ← 返回发现
        </button>

        <div className="card" style={{ textAlign: 'center', padding: '28px 16px' }}>
          <div style={{ fontSize: 56, marginBottom: 10 }}>🎉</div>
          <h2 style={{ marginBottom: 8 }}>牵线成功</h2>
          <p style={{ color: '#666', marginBottom: 18, lineHeight: 1.7 }}>
            女生已同意认识你
            <br />
            复制微信号后去添加好友，备注“AI相亲”
          </p>

          {loading ? (
            <div className="loading">加载中...</div>
          ) : error ? (
            <div style={{ color: '#f44336' }}>
              ❌ {error}
              <div style={{ marginTop: 12 }}>
                <button className="btn btn-primary" onClick={() => window.location.reload()}>
                  重试
                </button>
              </div>
            </div>
          ) : (
            <>
              <div
                style={{
                  background: '#f7f7f7',
                  borderRadius: 12,
                  padding: '14px 12px',
                  margin: '12px 0',
                  wordBreak: 'break-all'
                }}
              >
                <div style={{ fontSize: 13, color: '#999', marginBottom: 6 }}>对方微信号</div>
                <div style={{ fontSize: 20, fontWeight: 700 }}>{wechatText || '未填写'}</div>
                {data?.nickname && (
                  <div style={{ marginTop: 6, color: '#999', fontSize: 13 }}>
                    对方昵称：{data.nickname}
                  </div>
                )}
              </div>

              <button
                className="btn btn-primary"
                onClick={copyWechat}
                disabled={!wechatText}
                style={{ width: '100%', padding: '14px 0', fontSize: 16 }}
              >
                复制微信号
              </button>
              <div style={{ marginTop: 12 }}>
                <button className="btn btn-secondary" onClick={() => navigate('/messages')}>
                  去消息中心
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MatchSuccess;

